import { cn } from "@/lib/utils";
import { Rocket, TrendingUp, Crown } from "lucide-react";

type Level = "low" | "mid" | "high";

const CONFIG = {
  low: {
    label: "Sleeper",
    Icon: Rocket,
    bg: "bg-blue-50/60 dark:bg-blue-900/15",
    ring: "ring-blue-200 dark:ring-blue-800",
    accent: "bg-blue-400 dark:bg-blue-500",
    icon: "text-blue-600 dark:text-blue-300",
    text: "text-blue-800 dark:text-blue-200",
    sub: "text-blue-700/70 dark:text-blue-300/70",
  },
  mid: {
    label: "Challenger",
    Icon: TrendingUp,
    bg: "bg-primary/10 dark:bg-primary/15",
    ring: "ring-primary/30 dark:ring-primary/40",
    accent: "bg-primary",
    icon: "text-primary",
    text: "text-primary-900 dark:text-primary-100",
    sub: "text-primary/70",
  },
  high: {
    label: "Dominacja w Zasięgu",
    Icon: Crown,
    bg: "bg-amber-50/60 dark:bg-amber-900/15",
    ring: "ring-amber-200 dark:ring-amber-800",
    accent: "bg-amber-400 dark:bg-amber-500",
    icon: "text-amber-600 dark:text-amber-300",
    text: "text-amber-900 dark:text-amber-100",
    sub: "text-amber-700/70 dark:text-amber-300/70",
  },
} as const;

export function LevelBadge({ level, className }: { level: Level; className?: string }) {
  const { label, Icon, bg, ring, accent, icon, text, sub } = CONFIG[level];

  return (
    <div
      aria-label={`Poziom: ${label}`}
      className={cn(
        "relative inline-flex items-center gap-4 px-8 py-5 rounded-sm ring-1 ring-inset cursor-default select-none shadow-md",
        bg,
        ring,
        className
      )}
    >
      <span
        aria-hidden
        className={cn("absolute left-0 -ml-2 top-1/2 -translate-y-1/2 h-12 w-2 rounded-sm", accent)}
      />
      <div className={cn("flex h-12 w-12 items-center justify-center rounded-md bg-white/80 dark:bg-white/10 ring-1", ring)}>
        <Icon className={cn("h-6 w-6", icon)} />
      </div>
      <div className="text-left leading-tight">
        <div className={cn("text-xs uppercase tracking-wider", sub)}>Poziom</div>
        <div className={cn("text-base font-bold", text)}>{label}</div>
      </div>
    </div>
  );
}
